<footer
  class="fixed bottom-0 left-64 flex w-[calc(100%-16rem)] items-baseline gap-5 border-t-2 border-t-gray-300 bg-white px-11 py-6"
>
  <ng-content></ng-content>
</footer>